import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";
import {Permission, Role} from "../models";
import {Response} from "@angular/http";

@Injectable()
export class RolesService extends Base2Service {


    getRoles(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'roles');
    }

    getRole(id: number): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'roles/' + id);
    }

    getPermissions(roleId: number): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'permissions/');
    }

    updateRole(role: Role): Observable<ResponseApi> {
        return this.request<ResponseApi>("PUT", `${AppSettings.apiUrl}roles/${role.Id}`, JSON.stringify(role));
    }

    addRole(role: Role): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", `${AppSettings.apiUrl}roles/add`, JSON.stringify(role));
    }

    deleteRole(id: number): Observable<ResponseApi> {
        return this.request<ResponseApi>("DELETE", AppSettings.apiUrl + 'roles/' + id);
    }
}
